var render = function () {
  var _vm$currentRound, _vm$currentRound2, _vm$currentRound$sent;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('section', {
    staticClass: "whack-a-mole",
    style: {
      backgroundImage: ("url(" + (_vm.sky) + ")")
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm$currentRound = _vm.currentRound) !== null && _vm$currentRound !== void 0 && _vm$currentRound.answer ? _c('h2', {
    staticClass: "word",
    attrs: {
      "role": "heading"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text-step": 0,
      "shouldBeCurrentStep": _vm.shouldTypeWord && !_vm.hasTypedWord,
      "shouldBeCompletedStep": _vm.hasTypedWord,
      "text": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : _vm$currentRound2.answer
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "sentence",
    attrs: {
      "id": "sentence"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text-step": 0,
      "shouldBeCurrentStep": _vm.shouldTypeSentence && !_vm.hasTypedSentence,
      "shouldBeCompletedStep": _vm.hasTypedSentence,
      "text": (_vm$currentRound$sent = _vm.currentRound.sentence) !== null && _vm$currentRound$sent !== void 0 ? _vm$currentRound$sent : ''
    }
  })], 1), _c('div', {
    staticClass: "moles-stage"
  }, [_c('text-display-list', {
    staticClass: "syllables-wrapper",
    attrs: {
      "text-size": 'large'
    }
  }, _vm._l(_vm.currentRound.syllables, function (syllable, index) {
    return _c('li', {
      key: index,
      staticClass: "syllable-container",
      class: ("syllable-" + index + " syllable-container-" + (_vm.currentRound.syllables.length))
    }, [_c('div', {
      class: ("dynamic-mole dynamic-mole-" + index)
    }, [_c('div', {
      staticClass: "syllable-banner"
    }, [_c('blinking-cursor-text', {
      staticClass: "type-line",
      attrs: {
        "shouldBeCurrentStep": _vm.moleIndex === index && !_vm.shouldTypeWord && !_vm.shouldTypeSentence,
        "shouldBeCompletedStep": _vm.isLastStepInRound && index < _vm.moleIndex || _vm.shouldTypeWord,
        "text-step": _vm.progress.stepIndex,
        "text": syllable
      }
    })], 1), _c('img', {
      staticClass: "mole-image",
      attrs: {
        "alt": "Mole image",
        "src": index % 2 == 0 ? _vm.leftMole : _vm.rightMole
      }
    })]), index < _vm.currentRound.syllables.length ? _c('img', {
      staticClass: "nest-image",
      attrs: {
        "alt": "Nest image",
        "id": ("nest-image-" + index),
        "src": _vm.nest
      }
    }) : _vm._e()]);
  }), 0), _c('img', {
    staticClass: "grass-image",
    attrs: {
      "alt": "Grass image",
      "src": _vm.grass
    }
  })], 1)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }